import { ImageHelper } from '../helpers/image.helper'

interface FooterMenuItem {
  label: string
  url: string
  condition?: string
  target?: string
  copy?: boolean
  action?: 'consent-dialog'
}

const HEADER_CONFIG = {
  TOP_BAR: {
    LEFT: [
      {
        title: 'topbar.left.about',
        href: '/lp/coolmate-101?itm_source=navbar',
      },
      // {
      //   title: 'topbar.left.84rising',
      //   href: '/84rising?itm_source=navbar',
      // },
      {
        title: 'topbar.left.coolxprint',
        href: '/cxp',
      },
      {
        title: 'topbar.left.care&share',
        href: '/collection/care-and-share',
      },
      {
        title: 'topbar.left.coolx',
        href: '/graphic-tee?itm_source=navbar',
      },
    ],
    RIGHT: [
      {
        title: 'topbar.right.store',
        href: '/stores?itm_source=navbar',
        className: 'opacity-60 hover:opacity-100',
      },
      {
        title: 'topbar.right.newsroom',
        href: 'https://newsroom.coolmate.me/',
        className: 'opacity-60 hover:opacity-100',
        target: '_blank',
      },
    ],
  },
}

const FOOTER_CONFIG = {
  title: 'title',
  description: 'description',
  feedback: {
    title: 'feedback.title',
    link: 'https://form.omicrm.io/4115e15i615115107e556i53?lng=vi',
  },
  contact: {
    hotline: {
      title: 'contact.hotline.title',
      numbers: ['1900.272737', '028.7777.2737'],
      workingHours: 'contact.hotline.workingHours',
      iconUrl: '/images/footer/icon-hotline.svg',
    },
    email: {
      title: 'contact.email.title',
      address: 'contact.email.address',
      iconUrl: '/images/footer/icon-email.svg',
    },
  },
  socials: [
    {
      platform: 'socials.facebook',
      iconUrl: '/images/footer/icon-facebook.svg',
      url: 'https://www.facebook.com/coolmate.me',
    },
    {
      platform: 'socials.zalo',
      iconUrl: '/images/footer/icon-zalo.svg',
      url: 'https://zalo.me/1517736583279228381',
    },
    {
      platform: 'socials.tiktok',
      iconUrl: '/images/footer/icon-tiktok.svg',
      url: 'https://www.tiktok.com/@cool.coolmate',
    },
    {
      platform: 'socials.instagram',
      iconUrl: '/images/footer/icon-instagram.svg',
      url: 'https://www.instagram.com/coolmate.me/',
    },
    {
      platform: 'socials.youtube',
      iconUrl: '/images/footer/icon-youtube.svg',
      url: 'https://www.youtube.com/channel/UCWw8wLlodKBtEvVt1tTAsMA',
    },
  ],
  addresses: [
    {
      title: 'addresses.contact_address.title',
      address: 'addresses.contact_address.address',
    },
    {
      title: 'addresses.hn_office.title',
      address: 'addresses.hn_office.address',
    },
    {
      title: 'addresses.hn_center.title',
      address: 'addresses.hn_center.address',
    },
    {
      title: 'addresses.hcm_office.title',
      address: 'addresses.hcm_office.address',
    },
    {
      title: 'addresses.rnd_center.title',
      address: 'addresses.rnd_center.address',
    },
  ],
  companyInfo: {
    name: 'companyInfo.name',
    businessId: 'companyInfo.businessId',
    licenseInfo: 'companyInfo.licenseInfo',
    certifications: [
      {
        title: 'companyInfo.certifications.trust',
        url: 'https://tinnhiemmang.vn/danh-ba-tin-nhiem/coolmateme-1646213826',
        imageUrl: ImageHelper.getImageUrl('/uploads/March2022/handle_cert.png'),
      },
      {
        title: 'companyInfo.certifications.iso9001',
        url: 'https://www.dmca.com/Protection/Status.aspx?ID=c6fdbdee-127c-4cf1-923d-7efe75201df6&refurl=https://www.coolmate.me/',
        imageUrl: ImageHelper.getImageUrl(
          '/uploads/March2022/dmca_protected_15_120.png'
        ),
      },
      {
        title: 'companyInfo.certifications.iso14001',
        url: '#',
        imageUrl: '/images/footer/icon-iso-14001.png',
      },
      {
        title: 'companyInfo.certifications.hvnclc',
        url: 'http://online.gov.vn/nen-tang/9b0b76da-3e23-4280-ad35-327ff633e2bc',
        imageUrl: '/images/footer/icon-hvnclc.png',
      },
    ],
  },
  menu: [
    [
      {
        title: 'menu.coolclub.title',
        items: [
          {
            label: 'menu.coolclub.account',
            url: '/account/info?itm_source=footerm',
            condition: "Cookie::get('user_info')",
          },
          {
            label: 'menu.coolclub.register',
            url: '/register?itm_source=footerm',
            condition: "!Cookie::get('user_info')",
          },
          {
            label: 'menu.coolclub.privileges',
            url: '/coolclub?itm_source=footer',
          },
        ],
      },
      {
        title: 'menu.docs.title',
        items: [
          {
            label: 'menu.docs.recruit',
            url: '/lp/coolmate-101?itm_source=footer',
          },
          {
            label: 'menu.docs.copyright',
            url: 'https://wipopublish.ipvietnam.gov.vn/wopublish-search/public/trademarks;jsessionid=535B41AF193B2582C65163B5D64B63AA?0&query=*coolmate*',
            target: '_blank',
          },
        ],
      },
    ],
    [
      {
        title: 'menu.policy.title',
        items: [
          {
            label: 'menu.policy.return_offline',
            url: '/page/chinh-sach-doi-tra-tai-cua-hang',
          },
          {
            label: 'menu.policy.return',
            url: '/page/dich-vu-60-ngay-doi-tra',
          },
          {
            label: 'menu.policy.promotion',
            url: '/page/chuong-trinh-va-chinh-sach-khuyen-mai-tai-coolmate',
          },
          {
            label: 'menu.policy.privacy',
            url: '/page/chinh-sach-bao-mat-thong-tin-ca-nhan',
          },
          {
            label: 'menu.policy.shipping',
            url: '/page/dich-vu-giao-hang-coolmate',
          },
          {
            label: 'menu.policy.pricing',
            url: '/page/chinh-sach-gia',
          },
          {
            label: 'menu.policy.payment_refund',
            url: '/page/chinh-sach-thanh-toan-hoan-tien',
          },
          {
            label: 'menu.policy.complaint',
            url: '/page/tiep-nhan-va-giai-quyet-khieu-nai',
          },
          {
            label: 'menu.policy.restriction',
            url: '/page/dieu-kien-han-che',
          },
        ],
      },
      {
        title: 'menu.coolmate.title',
        items: [
          {
            label: 'menu.coolmate.newsroom',
            url: 'https://newsroom.coolmate.me/',
            target: '_blank',
          },
          {
            label: 'menu.coolmate.changelog',
            url: '/page/changelog?itm_source=footer',
          },
          {
            label: 'menu.policy.cookies',
            url: '',
            action: 'consent-dialog',
          },
        ],
      },
    ],
    [
      {
        title: 'menu.care.title',
        items: [
          {
            label: 'menu.care.experience',
            url: '/page/11-dich-vu-tai-coolmate-co-the-ban-chua-biet',
          },
          {
            label: 'menu.care.faq',
            url: '/page/faqs',
          },
        ],
      },
      {
        title: 'menu.knowledge.title',
        items: [
          {
            label: 'menu.knowledge.community_threads',
            url: '/community-threads',
          },
          {
            label: 'menu.knowledge.size_male',
            url: '/huong-dan-chon-size-do-nam',
          },
          {
            label: 'menu.knowledge.size_female',
            url: '/huong-dan-chon-size-do-nu',
          },
          {
            label: 'menu.knowledge.blog',
            url: '/blog',
          },
        ],
      },
    ],
    [
      {
        title: 'menu.about.title',
        items: [
          {
            label: 'menu.about.rules',
            url: '/page/quy-tac-ung-xu-cua-coolmate?itm_source=footer',
          },
          {
            label: 'menu.about.coolmate101',
            url: '/lp/coolmate-101?itm_source=footer',
          },
          {
            label: 'menu.about.excellent',
            url: '/page/11-dich-vu-tai-coolmate-co-the-ban-chua-biet?itm_source=footer',
          },
          {
            label: 'menu.about.story',
            url: '/page/coolmate-story?itm_source=footer',
          },
          {
            label: 'menu.about.factory',
            url: '/page/san-pham-coolmate-duoc-san-xuat-nhu-the-nao?itm_source=footer',
          },
          {
            label: 'menu.about.innovation',
            url: '/innovation?itm_source=footer',
          },
          {
            label: 'menu.about.care',
            url: '/collection/care-and-share?itm_source=footer',
          },
          {
            label: 'menu.about.sustainability',
            url: '/coolmate-esg?itm_source=footer',
          },
          {
            label: 'menu.about.vision',
            url: '/tam-nhin-2030',
          },
          // {
          //   label: 'menu.about.report',
          //   url: '/to-giac-khieu-nai',
          // },
        ],
      },
    ],
  ],
  menuMobile: [
    {
      title: 'menu.coolclub.title',
      items: [
        {
          label: 'menu.coolclub.account',
          url: '/account/info?itm_source=footerm',
          condition: "Cookie::get('user_info')",
        },
        {
          label: 'menu.coolclub.register',
          url: '/register?itm_source=footerm',
          condition: "!Cookie::get('user_info')",
        },
        {
          label: 'menu.coolclub.privileges',
          url: '/coolclub?itm_source=footer',
        },
      ],
    },
    {
      title: 'menu.policy.title',
      items: [
        {
          label: 'menu.policy.return_offline',
          url: '/page/chinh-sach-doi-tra-tai-cua-hang',
        },
        {
          label: 'menu.policy.return',
          url: '/page/dich-vu-60-ngay-doi-tra',
        },
        {
          label: 'menu.policy.promotion',
          url: '/page/chuong-trinh-va-chinh-sach-khuyen-mai-tai-coolmate',
        },
        {
          label: 'menu.policy.privacy',
          url: '/page/chinh-sach-bao-mat-thong-tin-ca-nhan',
        },
        {
          label: 'menu.policy.shipping',
          url: '/page/dich-vu-giao-hang-coolmate',
        },
        {
          label: 'menu.policy.pricing',
          url: '/page/chinh-sach-gia',
        },
        {
          label: 'menu.policy.payment_refund',
          url: '/page/chinh-sach-thanh-toan-hoan-tien',
        },
        {
          label: 'menu.policy.complaint',
          url: '/page/tiep-nhan-va-giai-quyet-khieu-nai',
        },
        {
          label: 'menu.policy.restriction',
          url: '/page/dieu-kien-han-che',
        },
        {
          label: 'menu.policy.cookies',
          url: '',
          action: 'consent-dialog',
        },
      ],
    },
    {
      title: 'menu.coolmate.title',
      items: [
        {
          label: 'menu.coolmate.newsroom',
          url: 'https://newsroom.coolmate.me/',
          target: '_blank',
        },
        {
          label: 'menu.coolmate.changelog',
          url: '/page/changelog?itm_source=footer',
        },
      ],
    },
    {
      title: 'menu.care.title',
      items: [
        {
          label: 'menu.care.experience',
          url: '/page/11-dich-vu-tai-coolmate-co-the-ban-chua-biet',
        },
        {
          label: 'menu.care.faq',
          url: '/page/faqs',
        },
      ],
    },
    {
      title: 'menu.knowledge.title',
      items: [
        {
          label: 'menu.knowledge.community_threads',
          url: '/community-threads',
        },
        {
          label: 'menu.knowledge.size_male',
          url: '/huong-dan-chon-size-do-nam',
        },
        {
          label: 'menu.knowledge.size_female',
          url: '/huong-dan-chon-size-do-nu',
        },
        {
          label: 'menu.knowledge.blog',
          url: '/blog',
        },
      ],
    },
    {
      title: 'menu.docs.title',
      items: [
        {
          label: 'menu.docs.recruit',
          url: '/lp/coolmate-101?itm_source=footer',
        },
        {
          label: 'menu.docs.copyright',
          url: 'https://wipopublish.ipvietnam.gov.vn/wopublish-search/public/trademarks;jsessionid=535B41AF193B2582C65163B5D64B63AA?0&query=*coolmate*',
          target: '_blank',
        },
      ],
    },
    {
      title: 'menu.about.title',
      items: [
        {
          label: 'menu.about.rules',
          url: '/page/quy-tac-ung-xu-cua-coolmate?itm_source=footer',
        },
        {
          label: 'menu.about.coolmate101',
          url: '/lp/coolmate-101?itm_source=footer',
        },
        {
          label: 'menu.about.excellent',
          url: '/page/11-dich-vu-tai-coolmate-co-the-ban-chua-biet?itm_source=footer',
        },
        {
          label: 'menu.about.story',
          url: '/page/coolmate-story?itm_source=footer',
        },
        {
          label: 'menu.about.factory',
          url: '/page/san-pham-coolmate-duoc-san-xuat-nhu-the-nao?itm_source=footer',
        },
        {
          label: 'menu.about.innovation',
          url: '/innovation?itm_source=footer',
        },
        {
          label: 'menu.about.care',
          url: '/collection/care-and-share?itm_source=footer',
        },
        {
          label: 'menu.about.sustainability',
          url: '/coolmate-esg?itm_source=footer',
        },
        {
          label: 'menu.about.vision',
          url: '/tam-nhin-2030',
        },
      ],
    },
    {
      title: 'menu.contact.title',
      items: [
        {
          label: 'addresses.contact_address.full',
          url: '',
          copy: true,
        },
        {
          label: 'addresses.hn_office.full',
          url: '',
          copy: true,
        },
        {
          label: 'addresses.hn_center.full',
          url: '',
          copy: true,
        },
        {
          label: 'addresses.hcm_office.full',
          url: '',
          copy: true,
        },
        {
          label: 'addresses.rnd_center.full',
          url: '',
          copy: true,
        },
      ],
    },
  ] satisfies { title: string; items: FooterMenuItem[] }[],
}

export const LAYOUT_CONFIG = {
  HEADER: HEADER_CONFIG,
  FOOTER: FOOTER_CONFIG,
}
